export default [
    {
        "company_id": 6,
        "category_name": null,
        "groups_name": null,
        "industry_name": null,
        "created_by_name": null,
        "company_size": "200",
        "status": null,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-31T10:55:47.621831Z",
        "updated_at": null,
        "archived_at": null,
        "deleted_at": null,
        "company_name": "Pranathi Software Services Private Limited",
        "company_domain": "pss",
        "company_owner": "Admin",
        "description": null,
        "founded_year": null,
        "headquarters": null,
        "logo_url": null,
        "website": null,
        "linkedin_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "x_url": null,
        "specialties": null,
        "user_ids": null,
        "company_email": "pss@pranathiss.com",
        "mobile_phone": "9876543210",
        "last_activity_type": null,
        "last_activity_date": "2025-10-31T10:55:47.622064Z",
        "private": false,
        "street_address": null,
        "street_address_line_2": null,
        "pincode": null,
        "company_type": "child",
        "created_by": null,
        "category": null,
        "group": null,
        "industry": null,
        "size": null,
        "country": null,
        "state": null,
        "city": null,
        "label": null,
        "parent_company": null
    },
    {
        "company_id": 5,
        "category_name": null,
        "groups_name": null,
        "industry_name": null,
        "created_by_name": null,
        "company_size": "90",
        "status": null,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-31T07:51:00.330730Z",
        "updated_at": null,
        "archived_at": null,
        "deleted_at": null,
        "company_name": "Vitel Global Services",
        "company_domain": "vgs",
        "company_owner": "Admin",
        "description": null,
        "founded_year": null,
        "headquarters": null,
        "logo_url": null,
        "website": null,
        "linkedin_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "x_url": null,
        "specialties": null,
        "user_ids": null,
        "company_email": "vitel@vitelglobal.com",
        "mobile_phone": "8745963210",
        "last_activity_type": null,
        "last_activity_date": "2025-10-31T07:51:00.330956Z",
        "private": false,
        "street_address": null,
        "street_address_line_2": null,
        "pincode": null,
        "company_type": "parent",
        "created_by": null,
        "category": null,
        "group": null,
        "industry": null,
        "size": null,
        "country": null,
        "state": null,
        "city": null,
        "label": null,
        "parent_company": null
    },
    {
        "company_id": 4,
        "category_name": null,
        "groups_name": null,
        "industry_name": null,
        "created_by_name": null,
        "company_size": "75",
        "status": null,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-31T07:20:08.627784Z",
        "updated_at": null,
        "archived_at": null,
        "deleted_at": null,
        "company_name": "VGTS",
        "company_domain": "vgts",
        "company_owner": "Admin",
        "description": null,
        "founded_year": null,
        "headquarters": null,
        "logo_url": null,
        "website": null,
        "linkedin_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "x_url": null,
        "specialties": null,
        "user_ids": null,
        "company_email": "vgts@vgts.com",
        "mobile_phone": "8521479630",
        "last_activity_type": null,
        "last_activity_date": "2025-10-31T07:20:08.628015Z",
        "private": false,
        "street_address": null,
        "street_address_line_2": null,
        "pincode": null,
        "company_type": "child",
        "created_by": null,
        "category": null,
        "group": null,
        "industry": null,
        "size": null,
        "country": null,
        "state": null,
        "city": null,
        "label": null,
        "parent_company": null
    },
    {
        "company_id": 3,
        "category_name": null,
        "groups_name": null,
        "industry_name": null,
        "created_by_name": null,
        "company_size": "30",
        "status": null,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-31T07:09:35.590121Z",
        "updated_at": null,
        "archived_at": null,
        "deleted_at": null,
        "company_name": "Varun Digitals",
        "company_domain": "vd",
        "company_owner": "Admin",
        "description": null,
        "founded_year": null,
        "headquarters": null,
        "logo_url": null,
        "website": null,
        "linkedin_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "x_url": null,
        "specialties": null,
        "user_ids": null,
        "company_email": "varun@varundigital.com",
        "mobile_phone": "9632587410",
        "last_activity_type": null,
        "last_activity_date": "2025-10-31T07:09:35.590348Z",
        "private": false,
        "street_address": null,
        "street_address_line_2": null,
        "pincode": null,
        "company_type": "child",
        "created_by": null,
        "category": null,
        "group": null,
        "industry": null,
        "size": null,
        "country": null,
        "state": null,
        "city": null,
        "label": null,
        "parent_company": null
    },
    {
        "company_id": 2,
        "category_name": null,
        "groups_name": null,
        "industry_name": null,
        "created_by_name": null,
        "company_size": "76",
        "status": null,
        "archived": false,
        "is_deleted": false,
        "created_at": "2025-10-31T06:59:14.258057Z",
        "updated_at": null,
        "archived_at": null,
        "deleted_at": null,
        "company_name": "MSCD",
        "company_domain": "mscd",
        "company_owner": "Admin",
        "description": null,
        "founded_year": null,
        "headquarters": null,
        "logo_url": null,
        "website": null,
        "linkedin_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "x_url": null,
        "specialties": null,
        "user_ids": null,
        "company_email": "mscd@mscd.com",
        "mobile_phone": "7896541230",
        "last_activity_type": null,
        "last_activity_date": "2025-10-31T06:59:14.258285Z",
        "private": false,
        "street_address": null,
        "street_address_line_2": null,
        "pincode": null,
        "company_type": "child",
        "created_by": null,
        "category": null,
        "group": null,
        "industry": null,
        "size": null,
        "country": null,
        "state": null,
        "city": null,
        "label": null,
        "parent_company": null
    }
]